
export const MoreInformation = [
  {
    title: "Medición Exacta de Niveles y Caudales",
    icon: "Settings",
    description:
      "Equipados con sensores de última generación, registramos con precisión el nivel freático y el caudal de descarga, asegurando mediciones fiables y constantes.",
  },
  {
    title: "Registro y Envío Automatizado de Datos",
    icon:"Straighten",
    description:
      "Nuestro DataLogger no solo captura los datos de los sensores, sino que también los envía automáticamente a nuestro servidor y de allí directamente a la DGA, simplificando procesos.",
  },
  {
    title: "Conformidad Legal Sin Esfuerzos",
    icon: "Balance",
    description:
      "Automatizamos el envío de datos cumpliendo con las normativas de la DGA, eliminando la necesidad de intervención manual y asegurando el cumplimiento efectivo de las regulaciones.",
  },
  {
    title: "Fiabilidad en Cada Medición",
    icon: "CellWifi",
    description:
      "Confía en nuestra tecnología para una gestión del agua responsable y alineada con las exigencias legales, proporcionando datos continuos y precisos a las autoridades.",
  },
  {
    title: "Mantenimiento y Soporte Continuo",
    icon: "PhoneAndroid",
    description:
      "Con nuestro servicio de suscripción, garantizamos la operatividad y actualización constante del sistema, asegurando que la tecnología de monitoreo funcione óptimamente y sin interrupciones.",
  },
];

export default MoreInformation;
